module.exports = __webpack_public_path__ + "img/Produksi Grafika.dd72e567.jpg";